import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=b8c22188&"
import script from "./ImageCarousel.vue?vue&type=script&lang=ts&"
export * from "./ImageCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./ImageCarousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports